// PAK — mock & static data (Turkish)

export const SERVICES = {
  standart: {
    key: "standart",
    label: "Standart Temizlik",
    description: "Genel temizlik, tozalma, süpürme, paspaslama, banyo & mutfak.",
    image: "https://images.pexels.com/photos/7061333/pexels-photo-7061333.jpeg",
    fromPrice: 700,
  },
};

export const ADDONS = [
  { key: "derin", label: "Derin Temizlik", price: 600, description: "Detaylı, köşe & kenar dahil derin temizlik." },
  { key: "cam", label: "Cam Silme", price: 300, description: "İç & dış cam, çerçeve ve pervaz." },
  { key: "koltuk", label: "Koltuk & Halı Yıkama", price: 400, description: "Profesyonel makineyle yerinde yıkama." },
  { key: "insaat", label: "İnşaat Sonrası Temizlik", price: 900, description: "Boya, toz, moloz sonrası özel temizlik." },
  { key: "buzdolabi", label: "Buzdolabı / Fırın İçi", price: 250, description: "Beyaz eşya iç temizliği." },
];

export const CATEGORIES = [
  {
    key: "standart",
    label: "Standart Temizlik",
    fromPrice: 700,
    desc: "Haftalık veya tek seferlik genel temizlik.",
    icon: "Sparkles",
    featured: true,
    image: "https://images.pexels.com/photos/7061333/pexels-photo-7061333.jpeg",
  },
  {
    key: "derin",
    label: "Derin Temizlik",
    fromPrice: 1200,
    desc: "Detaylı, mevsimlik, tam kapsamlı temizlik.",
    icon: "Droplets",
    image: "https://images.pexels.com/photos/6196685/pexels-photo-6196685.jpeg",
  },
  {
    key: "cam",
    label: "Cam Silme",
    fromPrice: 300,
    desc: "İç & dış cam, pervaz ve çerçeveler.",
    icon: "PanelTop",
  },
  {
    key: "koltuk",
    label: "Koltuk & Halı Yıkama",
    fromPrice: 400,
    desc: "Yerinde profesyonel yıkama hizmeti.",
    icon: "Sofa",
  },
  {
    key: "insaat",
    label: "İnşaat Sonrası Temizlik",
    fromPrice: 900,
    desc: "Tadilat sonrası özel ekipman temizliği.",
    icon: "Hammer",
  },
  {
    key: "ofis",
    label: "Ofis Temizliği",
    fromPrice: 850,
    desc: "Düzenli ofis ve iş yeri temizliği.",
    icon: "Briefcase",
  },
];

export const PROPERTY_TYPES = [
  { key: "daire", label: "Daire", icon: "Building2" },
  { key: "mustakil", label: "Müstakil Ev", icon: "Home" },
  { key: "ofis", label: "Ofis", icon: "Briefcase" },
];

export const ROOM_SIZES = [
  { key: "1+1", label: "1+1", price: 700, hours: 2 },
  { key: "2+1", label: "2+1", price: 950, hours: 3 },
  { key: "3+1", label: "3+1", price: 1200, hours: 4 },
  { key: "4+1", label: "4+1 ve üzeri", price: 1500, hours: 5 },
];

export const TIME_SLOTS = [
  { key: "sabah", label: "Sabah", range: "08:00 – 12:00" },
  { key: "oglen", label: "Öğlen", range: "12:00 – 16:00" },
  { key: "aksam", label: "Akşam", range: "16:00 – 20:00" },
];

export const DISTRICTS = [
  "Bornova", "Karşıyaka", "Konak", "Buca", "Bayraklı",
  "Çiğli", "Gaziemir", "Balçova", "Narlıdere", "Karabağlar",
];

// Real İzmir mahalleler per district. A representative set per ilçe.
export const MAHALLELER = {
  "Bornova": [
    "Atatürk", "Erzene", "Evka 3", "Evka 4", "Kazımdirik", "Mevlana",
    "Çamiçi", "Yeşilçam", "Doğanlar", "Pınarbaşı", "Naldöken", "Kemalpaşa Cad.",
  ],
  "Karşıyaka": [
    "Bostanlı", "Mavişehir", "Bahriye Üçok", "Aksoy", "Atakent",
    "Donanmacı", "Tuna", "Şemikler", "Cumhuriyet", "Yalı", "Alaybey",
  ],
  "Konak": [
    "Alsancak", "Güzelyalı", "Göztepe", "Hatay", "Basmane",
    "Mithatpaşa", "Çankaya", "Akıncılar", "Konak", "Üçkuyular",
  ],
  "Buca": [
    "Adatepe", "Şirinyer", "Yıldız", "Tınaztepe", "Ufuk",
    "Kuruçeşme", "Hürriyet", "Çağdaş", "Vali Rahmi Bey", "Atatürk", "Dumlupınar",
  ],
  "Bayraklı": [
    "Mansuroğlu", "Adalet", "Manavkuyu", "Soğukkuyu", "Onur",
    "Tepekule", "Org. Nafiz Gürman", "Çay", "Yamanlar",
  ],
  "Çiğli": [
    "Ataşehir", "Balatçık", "Köyiçi", "Şirintepe", "Egekent",
    "Esentepe", "Küçük Çiğli", "Büyük Çiğli", "Harmandalı",
  ],
  "Gaziemir": [
    "Atıfbey", "Beyazevler", "Üniversite", "Sarnıç", "Aktepe",
    "Atatürk", "Binbaşı Reşatbey", "Fatih", "Menderes",
  ],
  "Balçova": [
    "Onur", "Eğitim", "Çetin Emeç", "Bahçelerarası", "Korutürk",
    "Teleferik", "Fevzi Çakmak", "İnciraltı",
  ],
  "Narlıdere": [
    "İlkkurşun", "Atıfbey", "Limanreis", "2. İnönü", "Huzur",
    "Çatalkaya", "Yenikale", "Altıevler",
  ],
  "Karabağlar": [
    "Bozyaka", "Yeşillik", "Üçkuyular", "Esenyalı", "Vatan",
    "Cennetçeşme", "Aşık Veysel", "İhsan Alyanak", "Bahçelievler", "Limontepe",
  ],
};

export const TESTIMONIALS = [
  {
    name: "Zeynep A.",
    district: "Karşıyaka",
    stars: 5,
    text: "Talep oluşturmak çok kolaydı, uzman tam vaktinde geldi. Evim mis gibi oldu.",
  },
  {
    name: "Burak T.",
    district: "Bornova",
    stars: 5,
    text: "Talep oluşturdum, kısa sürede birkaç uzmandan teklif aldım. İstediğimi seçtim, çok pratik.",
  },
  {
    name: "Selin M.",
    district: "Gaziemir",
    stars: 5,
    text: "İnşaat sonrası temizlik için çağırdım, sonuç harika.",
  },
];

export const FAQS = [
  {
    q: "PAK nasıl çalışır?",
    a: "Ücretsiz bir talep oluşturursunuz; hizmet sağlayıcılar talebinizi görüp size teklif gönderir. Teklifleri karşılaştırır, uzmanla iletişime geçer ve anlaşırsınız. PAK ödeme almaz; anlaşma ve ödeme doğrudan sizinle uzman arasındadır.",
  },
  {
    q: "Talep oluşturmak ücretli mi?",
    a: "Hayır. Müşteriler için talep oluşturmak tamamen ücretsizdir. PAK'a herhangi bir ödeme yapmazsınız.",
  },
  {
    q: "Fiyatlar nasıl belirleniyor?",
    a: "Talep oluştururken yalnızca tahmini bir fiyat aralığı gösterilir. Kesin fiyat, hizmet sağlayıcıların size göndereceği tekliflerde belirlenir.",
  },
  {
    q: "Teklif gelince ne oluyor?",
    a: "Bir uzman teklif gönderdiğinde, o talep için karşılıklı bir mesajlaşma kanalı açılır ve telefon numaralarınız paylaşılır. Uzmanla doğrudan konuşup anlaşabilirsiniz.",
  },
  {
    q: "Uzmanlar nasıl doğrulanıyor?",
    a: "Tüm PAK uzmanları kimlik doğrulaması, referans kontrolü ve adli sicil incelemesinden geçer.",
  },
];

export function calcBasePrice(roomKey) {
  const r = ROOM_SIZES.find((x) => x.key === roomKey);
  return r ? r.price : 0;
}

export function calcBathroomExtra(count) {
  // 1 banyo dahil, her ek banyo +120
  return Math.max(0, count - 1) * 120;
}

export function calcAddonsTotal(addonKeys) {
  return ADDONS.filter((a) => addonKeys.includes(a.key)).reduce((s, a) => s + a.price, 0);
}

export function calcEstimatedHours(roomKey, addonKeys) {
  const r = ROOM_SIZES.find((x) => x.key === roomKey);
  const base = r ? r.hours : 2;
  const extra = addonKeys.length * 0.75;
  return Math.round((base + extra) * 10) / 10;
}
